import actionTypes from 'redux/actions/actionTypes'

const defaultState = []

function setMediaSlide(state, action) {
	return [
		...state,
		{
			...action.mediaSlide,
			lessonUid: action.lessonUid,
			externalLessonUid: action.externalLessonUid,
		},
	]
}

function clearMediaData() {
	return defaultState
}

function saveHandouts(state, action) {
	const mediaIndex = state.findIndex(media => media.uid === action.mediaUid)
	if (mediaIndex !== -1) {
		return [
			...state.slice(0, mediaIndex),
			{
				...state[mediaIndex],
				handouts: action.handouts,
			},
			...state.slice(mediaIndex + 1),
		]
	} else {
		return state
	}
}

function replaceMediaLessonUidByDownloaded(state, action) {
	const mediaIndex = state.findIndex(media => media.lessonUid === action.entityUID)
	const newLessonUid = action.payload && action.payload.presentation && action.payload.presentation.data.entityUID

	if (mediaIndex === -1 || !newLessonUid) {
		return state
	}

	return [
		...state.slice(0, mediaIndex),
		{
			...state[mediaIndex],
			lessonUid: newLessonUid,
		},
		...state.slice(mediaIndex + 1),
	]
}

const mediaSlidesReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.MEDIA_SLIDE_FETCH_SUCCESS:
			return setMediaSlide(state, action)
		case actionTypes.MY_LIBRARY_PREVIEW_EXIT:
			return clearMediaData()
		case actionTypes.INTERACTIVE_VIDEO_HANDOUTS_FETCHED:
			return saveHandouts(state, action)
		case actionTypes.CART_BUY_PRODUCT_SUCCESS:
			return replaceMediaLessonUidByDownloaded(state, action)
		default:
			return state
	}
}

export default mediaSlidesReducer
